import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-light-svg-icons';
import clsx from 'clsx';
import React from 'react';
import styles from './InboxAvatar.module.scss';

interface InboxAvatarProps {
    name: string;
    isProspect?: boolean;
    size?: 'medium' | 'large';
    className?: string;
}

const initialsOf = (name: string): string =>
    name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map(part => part[0])
        .join('')
        .toUpperCase();

export const InboxAvatar: React.FC<InboxAvatarProps> = ({ name, isProspect, size = 'medium', className }) => (
    <div className={clsx(styles.root, size === 'large' && styles.large, className)}>
        {isProspect ? <FontAwesomeIcon icon={faUser} /> : initialsOf(name)}
    </div>
);

export default InboxAvatar;
